<template>
  <div>

      <!-- ##### header section##### -->
    <div class="breadcumb-area bg-img" style="background-image: url(img/bg-img/bg-8.jpg);">
        <div class="container h-100">
            <div class="row h-100 align-items-center">
                <div class="col-12 col-md-6">
                    <div class="breadcumb-text">
                        <h2>Haz un donativo</h2>                        
                        <p>
                          ... El que siembra escasamente, también segará escasamente; y el que siembra generosamente, generosamente también segará.
                          <br> <small>2 Corintios 9:6</small>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- ##### header section ##### -->

    <div class="container">
      <div class="row mt-5 mb-5">
        <div class="col-md-6 offset-md-3 shadow p-5">
            <p style="font-size:1.1rem">
              Puedes realizar su donativo através del siguiente botón de pago, por medio de Paypal.
            </p>
            <div class="text-center"> 
              <form action="https://www.paypal.com/cgi-bin/webscr" method="post" target="_top" style="margin-top:2rem; margin-bottom:2rem;">
                <input type="hidden" name="cmd" value="_donations" />
                <input type="hidden" name="business" value="YQ2GT3SCWVMWC" />
                <input type="hidden" name="currency_code" value="USD" />
                <input type="image" src="https://www.paypalobjects.com/es_XC/i/btn/btn_donateCC_LG.gif" border="0" name="submit"
                    title="PayPal - The safer, easier way to pay online!" alt="Donar con el botón PayPal" />
                <img alt="" border="0" src="https://www.paypal.com/es_US/i/scr/pixel.gif" width="1" height="1" />
              </form>
            </div>


                <p style="font-size:1.1rem">
                    O bien, puede enviar su ofrenda o donativo por cheque o money order al <b> P.O.Box 26950, 
            Los Angeles CA 90026,</b> a nombre de <b> Iglesia La Senda Antigua.</b>
                </p>

        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {};
</script>

<style>
</style>